import { render, staticRenderFns } from "./phiFormula.vue?vue&type=template&id=2a2d74ed&"
import script from "./phiFormula.vue?vue&type=script&lang=ts&"
export * from "./phiFormula.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports